export default __webpack_public_path__ + "static/DUX - Brandon Bai-10d8e7c8e600e85079f63a78e2936d78.png";